import { Grid2,Paper, Typography} from "@mui/material";
import React from 'react'
import styles from './Footer.module.css'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

export function Footer() {
  return (
   <Grid2 className={styles.FooterContainer} > 
   <Grid2 container  justifyContent="space-evenly">
        <Grid2 className={styles.infocontainer}>
              <Typography  className={styles.header}>Information</Typography>
              <Grid2 className={styles.textdata}>
                <Typography className={styles.foottext}>Home</Typography>
                <Typography className={styles.foottext}>About Us</Typography>
                <Typography className={styles.foottext}>Products</Typography>
                <Typography className={styles.foottext}>Certificates</Typography>
                <Typography className={styles.foottext}>Blog</Typography>
                <Typography className={styles.foottext}>Contact Us</Typography>
              </Grid2>
        </Grid2> 
        <Grid2 className={styles.infocontainer}>
              <Typography  className={styles.header}>Product Range</Typography>
              <Grid2 className={styles.textdata}>
                <Typography className={styles.foottext}>turmeric</Typography>
                <Typography className={styles.foottext}>cumin</Typography>
                <Typography className={styles.foottext}>coriander</Typography>
                <Typography className={styles.foottext}>black </Typography>
                <Typography className={styles.foottext}>pepper</Typography>
                <Typography className={styles.foottext}>cardamom</Typography>
               
              </Grid2>
        </Grid2> 
        <Grid2 className={styles.infocontainer}>
              <Typography  className={styles.header}>Branches</Typography>
              <Grid2 className={styles.textdata}>
                <Typography className={styles.foottext}>Hyderabad</Typography>
                <Typography className={styles.foottext}>Chennai</Typography>
              </Grid2>
        </Grid2>
        <Grid2 className={styles.infocontainer}>
              <Typography  className={styles.header}>Stay Connected</Typography>
              <Grid2 className={styles.textdata}>
                <Grid2 container gap="10px" >
                    <LocationOnIcon sx={{color:"#960A0A"}}/>
                    <Typography className={styles.foottext}>
                        <b>Registered address:</b><br/>
                        Grow Beyond Global Business Pvt. Ltd.<br/>
                        HIVE, 4th Floor, Vasista Bhavan,<br/> opp. lane to, DLF Cyber City,  <br/> Indira Nagar,Gachibowli, <br/>  Hyderabad, Telangana 500032
                       
                    </Typography>
                </Grid2>
                <Grid2 container gap="10px" >
                    <CallIcon sx={{color:"green"}}/>
                <Typography className={styles.foottext}>
                 <b>Phone Number:</b><br/>
                 +91-76758 09054<br/>
                </Typography>
                </Grid2>
                <Grid2 container gap="10px" >
                <EmailIcon sx={{color:"#4285F4"}}/>
                <Typography className={styles.foottext}>
                    <b>Email:</b><br/>
                    sales@growbeyondglobal.com
                </Typography>
                </Grid2>
              </Grid2>
        </Grid2>  
        <Grid2 className={styles.infocontainer}>
              <Typography  className={styles.header}>Information</Typography>
              <Grid2 className={styles.textdata}>
                <Grid2 container gap="10px" >
                <YouTubeIcon sx={{color:"red"}}/>
                <Typography sx={{display:"flex",alignItems:"center",gap:"10px"}} className={styles.foottext}> YouTube</Typography>
                </Grid2>
                <Grid2 container gap="10px" >
                <FacebookIcon sx={{color:"#1877F2"}}/>
                <Typography className={styles.foottext}> Facebook</Typography>
                </Grid2>
                <Grid2 container gap="10px" >
                <TwitterIcon sx={{color:"#1da1f2"}}/>
                <Typography className={styles.foottext}> Twitter</Typography>
                </Grid2>
                <Grid2 container gap="10px" >
                <LinkedInIcon sx={{color:"#0077B5 "}}/>
                <Typography className={styles.foottext}> Linkedin</Typography>
                </Grid2>
                <Grid2 container gap="10px" >
                <InstagramIcon sx={{color:"#e95950"}}/>
                <Typography className={styles.foottext}> Instagram</Typography>
                </Grid2>
            </Grid2>    
        </Grid2> 
        </Grid2>  
        <Grid2 container justifyContent="center">
          <Typography sx={{color:"#fff",fontSize:"10px",marginTop:'20px'}}>Copyright © 2025.All Rights Reserved. ANSUM Technologies <hr  sx={{color:"#FFF"}} /> </Typography>
        </Grid2>
   </Grid2>
  )
}

 